import Vue from 'vue'
import VueRouter from 'vue-router'

import Contact from '@/pages/contact/contact'
// import ForFun from '@/pages/for-fun/for-fun'
import GetStarted from '@/pages/get-started/get-started'
import Home from '@/pages/home/home'
import MeetUs from '@/pages/meet-us/meet-us'
// import PageNotFound from '@/pages/404/404'
// import Resources from '@/pages/resources/resources'
import Services from '@/pages/services/services'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility-statement/accessibility-statement'
// import Smile from '@/pages/smile-for-a-lifetime/smile-for-a-lifetime'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      linkName: 'HOME',
      navigation: false,
      mobile: true,
      component: Home
    },
    {
      path: '/meet-us',
      name: 'meet-us',
      linkName: 'MEET US',
      navigation: true,
      component: MeetUs
    },
    {
      path: '/get-started',
      name: 'get-started',
      linkName: 'GET STARTED',
      navigation: true,
      component: GetStarted
    },
    {
      path: '/services',
      name: 'services',
      linkName: 'SERVICES',
      navigation: true,
      component: Services
    },
    {
      path: '/thank-you',
      name: 'thank-you',
      linkName: 'Thank You',
      navigation: false,
      component: ThankYou
    },
    {
      path: '/accessibility-statement',
      name: 'accessibility',
      linkName: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    // {
    //   path: '/resources',
    //   name: 'resources',
    //   linkName: 'RESOURCES',
    //   navigation: true,
    //   component: Resources
    // },
    // {
    //   path: '/for-fun',
    //   name: 'for-fun',
    //   linkName: 'FOR FUN',
    //   navigation: true,
    //   component: ForFun
    // },
    // {
    //   path: '/smile-for-a-lifetime',
    //   name: 'smile-for-a-lifetime',
    //   navigation: true,
    //   linkName: 'SMILE FOR A LIFETIME',
    //   component: Smile
    // },
    {
      path: '/contact',
      name: 'contact',
      linkName: 'CONTACT',
      navigation: true,
      component: Contact
    },
    {
      path: '/*',
      navigation: false,
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js